import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { filter, flatMap, takeUntil, tap } from "rxjs/operators";
import { TenantService } from "../services";

@Component({
    template: `
        <div fxLayout="column">
            <mat-toolbar>
                <h3>Edit Catalog {{catalog?.title}}</h3>
                <span fxFlex></span>
            </mat-toolbar>
            <nav mat-tab-nav-bar>
                <a mat-tab-link
                   [routerLink]="['streams']"
                   routerLinkActive #rlaStreams="routerLinkActive"
                   [active]="rlaStreams.isActive">Streams</a>
                <a mat-tab-link
                   [routerLink]="['categories']"
                   routerLinkActive #rlaCategories="routerLinkActive"
                   [active]="rlaCategories.isActive">Categories</a>
                <span fxFlex></span>
                <a mat-tab-link *ngIf="isSources" [routerLink]="['streams']">Back to Streams</a>
                <a mat-tab-link
                   *ngIf="!isSources"
                   [routerLink]="['streams/addSources']"
                   routerLinkActive #rla="routerLinkActive"
                   [active]="rla.isActive">Add Sources</a>
            </nav>
            <router-outlet></router-outlet>
        </div>
    `
})
export class CatalogEditComponent implements OnInit, OnDestroy {
    private cleanupTime = new Subject<void>();
    catalog: any;
    isSources: boolean;

    constructor(private route: ActivatedRoute,
                private router: Router, 
                private tenantService: TenantService) {}

    ngOnInit(): void {
        this.router.events
        .pipe(
            filter(e => e instanceof NavigationEnd),
            tap((e: NavigationEnd) => this.isSources = e.url.split('/').includes('sources')),
            takeUntil(this.cleanupTime)
        ).subscribe();

        this.route.params
        .pipe(
            flatMap(params => this.tenantService.getCatalog(params.catalogId)),
            takeUntil(this.cleanupTime)
        )
        .subscribe(catalog => this.catalog = catalog);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}